import React, { useState, useEffect } from 'react';

// Добавляем пропс value
export default function TeamSearchInput({ teams, onTeamSelect, placeholder = "Найти команду...", value }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [selectedTeamName, setSelectedTeamName] = useState('');

  // СЛЕДИМ ЗА ВНЕШНИМ ИЗМЕНЕНИЕМ (сброс при value === null)
  useEffect(() => {
    if (!value) {
      setSearchTerm('');
      setSelectedTeamName('');
    }
  }, [value]);

  useEffect(() => {
    if (searchTerm) {
      setSuggestions(teams.filter(t => t.name.toLowerCase().includes(searchTerm.toLowerCase())).slice(0, 5));
    } else {
      setSuggestions([]);
    }
  }, [searchTerm, teams]);

  const handleSelect = (team) => {
    onTeamSelect(team);
    setSearchTerm('');
    setSelectedTeamName(team.name);
  };

  const handleChange = (e) => {
    setSearchTerm(e.target.value);
    setSelectedTeamName('');
    onTeamSelect(null);
  };

  return (
    <div className="team-search-container">
      <input type="text" value={selectedTeamName || searchTerm} onChange={handleChange} placeholder={placeholder} />
      {suggestions.length > 0 && (
        <ul className="suggestions-list">
          {suggestions.map(team => (
            <li key={team.id} onMouseDown={() => handleSelect(team)}>
              {team.name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
